import { Input } from 'antd';
import { SolarCalcPage, ItemsMap } from '../solar-calculator';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFChecked from '@/components/UI/svg/blade/calculator/EFChecked';
import NextImage from '@/components/NextImage';

export default function Step2({ callBack, calObj }: any) {
    const { useState, useLang, gtm, useRouter } = useGlobal();
    const { t } = useLang('calculatorssolarpanels');
    const { locale } = useRouter();
    const [checked, setChecked] = useState(calObj?.check2 ?? '');
    const [input, setInput] = useState('');
    const dataMap: ItemsMap = {
        outdoor: {
            title: t('step1_text1'),
            data: [
                {
                    webp: 'https://websiteoss.ecoflow.com/upload/image/1749092492654/1.jpg',
                    img: 'https://websiteoss.ecoflow.com/upload/image/1749092492654/1.jpg',
                    text: t('step2_list1_text1'),
                },
                {
                    webp: 'https://websiteoss.ecoflow.com/upload/image/1749092493384/2.jpg',
                    img: 'https://websiteoss.ecoflow.com/upload/image/1749092493384/2.jpg',
                    text: t('step2_list1_text2'),
                },
                {
                    webp: 'https://websiteoss.ecoflow.com/upload/image/1749092493021/3.jpg',
                    img: 'https://websiteoss.ecoflow.com/upload/image/1749092493021/3.jpg',
                    text: t('step2_list1_text3'),
                },
                {
                    webp: 'https://websiteoss.ecoflow.com/upload/image/1749092493557/4.jpg',
                    img: 'https://websiteoss.ecoflow.com/upload/image/1749092493557/4.jpg',
                    text: t('step2_list1_text4'),
                },
                {
                    webp: 'https://websiteoss.ecoflow.com/upload/image/1749092493186/5.jpg',
                    img: 'https://websiteoss.ecoflow.com/upload/image/1749092493186/5.jpg',
                    text: t('step2_list1_text5'),
                },
                {
                    webp: 'https://websiteoss.ecoflow.com/upload/image/1749092492822/6.jpg',
                    img: 'https://websiteoss.ecoflow.com/upload/image/1749092492822/6.jpg',
                    text: t('step2_list1_text6'),
                },
            ],
        },
        home: {
            title: t('step1_text2'),
            data: [
                {
                    webp: 'https://websiteoss.ecoflow.com/upload/image/1749092645543/1.jpg',
                    img: 'https://websiteoss.ecoflow.com/upload/image/1749092645543/1.jpg',
                    text: t('step2_list2_text1'),
                },
                {
                    webp: 'https://websiteoss.ecoflow.com/upload/image/1749092645961/2.jpg',
                    img: 'https://websiteoss.ecoflow.com/upload/image/1749092645961/2.jpg',
                    text: t('step2_list2_text2'),
                },
                {
                    webp: 'https://websiteoss.ecoflow.com/upload/image/1749092645735/3.jpg',
                    img: 'https://websiteoss.ecoflow.com/upload/image/1749092645735/3.jpg',
                    text: t('step2_list2_text3'),
                },
                {
                    webp: 'https://websiteoss.ecoflow.com/upload/image/1749092646181/4.jpg',
                    img: 'https://websiteoss.ecoflow.com/upload/image/1749092646181/4.jpg',
                    text: t('step2_list2_text4'),
                },
            ],
        },
        work: {
            title: t('step1_text3'),
            data: [
                {
                    webp: 'https://websiteoss.ecoflow.com/upload/image/1749092756008/1.jpg',
                    img: 'https://websiteoss.ecoflow.com/upload/image/1749092756008/1.jpg',
                    text: t('step2_list3_text1'),
                },
                {
                    webp: 'https://websiteoss.ecoflow.com/upload/image/1749092756404/2.jpg',
                    img: 'https://websiteoss.ecoflow.com/upload/image/1749092756404/2.jpg',
                    text: t('step2_list3_text2'),
                },
                {
                    webp: 'https://websiteoss.ecoflow.com/upload/image/1749092756199/3.jpg',
                    img: 'https://websiteoss.ecoflow.com/upload/image/1749092756199/3.jpg',
                    text: t('step2_list3_text3'),
                },
                {
                    webp: 'https://websiteoss.ecoflow.com/upload/image/1749092756988/4.jpg',
                    img: 'https://websiteoss.ecoflow.com/upload/image/1749092756988/4.jpg',
                    text: t('step2_list3_text4'),
                },
                {
                    webp: 'https://websiteoss.ecoflow.com/upload/image/1749092756772/5.jpg',
                    img: 'https://websiteoss.ecoflow.com/upload/image/1749092756772/5.jpg',
                    text: t('step2_list3_text5'),
                },
                {
                    webp: 'https://websiteoss.ecoflow.com/upload/image/1749092756563/6.jpg',
                    img: 'https://websiteoss.ecoflow.com/upload/image/1749092756563/6.jpg',
                    text: t('step2_list3_text6'),
                },
            ],
        },
        others: {
            title: t('step1_text4'),
            data: [
                {
                    webp: 'https://websiteoss.ecoflow.com/upload/image/1749092868874/1.jpg',
                    img: 'https://websiteoss.ecoflow.com/upload/image/1749092868874/1.jpg',
                    text: '',
                },
            ],
        },
    };

    const [items, setItems] = useState(dataMap[calObj?.check1 as keyof ItemsMap]);

    const handleCheck = (key: number) => {
        if (calObj.check1 !== 'others') {
            setChecked(key === checked ? '' : key);
            callBack({ ...calObj, currentStep: key === checked ? 1 : 2, check2: key === checked ? '' : key });
        }
    };
    const handleNext = () => {
        callBack({ ...calObj, currentPage: SolarCalcPage.Step3 }, true);
        const option = items[checked]?.text;
        gtm.push({
            event: 'uaEvent',
            event_name: 'checklist_process2',
            step: 'Scenario_2',
            product_name: 'EcoFlow Solar Panel',
            button_name: 'Next',
            option_name: option || input,
        });
    };
    const handleBack = () => {
        callBack({ ...calObj, currentPage: SolarCalcPage.Step1, currentStep: 1, check2: undefined }, true);
    };
    const handleInputChange = (e: any) => {
        const v = e.target.value;
        setInput(v);
        setChecked(v ? 0 : '');
        callBack({
            ...calObj,
            currentStep: v ? 2 : 1,
            check2: v ? 0 : '',
        });
    };
    return (
        <div className={`step2 ${css.step2}`}>
            <p className="step2-title">{t('step1_title')}</p>
            <div className={`step2-wrapper`}>
                <p className="step2-subtitle">{items?.title}</p>
                <ul
                    className={`step2-box ${calObj?.check1 === 'others' ? 'others' : ''} ${
                        items?.data?.length % 2 === 0 && calObj?.check1 === 'home' ? 'even' : 'odd'
                    }`}
                >
                    {items?.data?.map((item: any, k: number) => (
                        <li className="step2-item" key={item?.text} onClick={() => handleCheck(k)}>
                            <div className="img-box">
                                <NextImage webpSrc={item?.webp || item?.img} src={item?.img} alt={item.text} aria-label={item.text} />
                                {checked === k && calObj?.check1 !== 'others' && (
                                    <>
                                        <div className="mask"></div>
                                        <EFChecked className="checked" />
                                    </>
                                )}
                            </div>
                            {item?.text && <p className="img-text">{item?.text}</p>}
                        </li>
                    ))}
                    {calObj?.check1 === 'others' && (
                        <Input
                            name="scenarios"
                            required
                            value={input}
                            className="step2-input"
                            maxLength={200}
                            onChange={handleInputChange}
                            placeholder={t('step2_list4_placeholder')}
                            aria-label={t('step2_list4_placeholder')}
                        />
                    )}
                </ul>
            </div>
            <div className="step2-btns">
                <button className="btn-back" onClick={handleBack}>
                    {t('common_back')}
                </button>
                <button
                    className="btn-next"
                    disabled={(checked === '' && calObj?.check1 !== 'others') || (!input && calObj?.check1 === 'others')}
                    onClick={handleNext}
                >
                    {t('common_next')}
                </button>
            </div>
        </div>
    );
}
